<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      流塘站<br>
站点介绍<br>
流塘站位于前进二路与流塘路交叉口。车站设置有5个出入口。地下一层为站厅层，地下二层为站台层。车站周边主要分布了规划中15号线流塘站、华耀大厦、御景国际酒店、中粮锦云、简阅书吧、嘉华花园东区流塘小学等。走进流塘站，引入眼帘是以“阳光+”的理念的装修风格，打造温暖、舒适的公共交通空间。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:36	23:32	12号线	4分钟	8分钟<br>
海上田园东	06:16	23:40	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:40	23:32	12号线	8分钟	8分钟<br>
海上田园东	06:17	23:40	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
前进二路东侧、流塘公园、亿铖达大厦、御景国际酒店、深圳正康骨科医院<br><br>
B出入口:<br>
前进二路东侧、流塘76区小区、富盈门、新庄园小区、君成雍和园<br><br>
C出入口:<br>
前进二路西侧、中粮锦云、富东花园、交通银行<br><br>
G出入口:<br>
前进二路西侧、流塘阳光花园、荔景小区<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 富盈门站<br>
606、M425、M250、718、Peak Special Line102、B864、M393、M131、M313、M371、高峰专线138<br><br>
C出入口:<br>
公交站名： 富盈门站<br>
606、M425、M250、718、Peak Special Line102、B864、M393、M131、M313、M371、高峰专线138<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>